import { render, staticRenderFns } from "./newCustomizePage.vue?vue&type=template&id=2a3594ef&scoped=true"
import script from "./newCustomizePage.vue?vue&type=script&lang=js"
export * from "./newCustomizePage.vue?vue&type=script&lang=js"
import style0 from "./newCustomizePage.vue?vue&type=style&index=0&id=2a3594ef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3594ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3594ef')) {
      api.createRecord('2a3594ef', component.options)
    } else {
      api.reload('2a3594ef', component.options)
    }
    module.hot.accept("./newCustomizePage.vue?vue&type=template&id=2a3594ef&scoped=true", function () {
      api.rerender('2a3594ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appRenovation/component/components/newCustomizePage.vue"
export default component.exports